import {SupplierOrderItem,CarcaseOrderItem, OrderItem} from '../../types';
import sortBy from 'lodash/sortBy';

export function sortItems(items : OrderItem[]) : OrderItem[]{
    return sortBy(items, ['sortOrder', 'dateCreated']);
    
}